import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'
import {isStaff} from '@github-ui/stats'
import {useLocalStorage} from '@github-ui/use-safe-storage/local-storage'

export const ENVIRONMENT_SETUP_CUBE_FLAG = 'copilot_chat_environment_setup_cube'
export const ENVIRONMENT_SETUP_CUBE_STORAGE_KEY = 'copilot-chat-environment-setup-cube'

export interface EnvironmentSetupLoaderPreference {
  cubeEnabled: boolean
  setCubeEnabled: ((enabled: boolean) => void) | undefined
}

export function useEnvironmentSetupLoader(): EnvironmentSetupLoaderPreference {
  const {isBrowser} = useRuntimeEnvironment()
  const [cubeEnabled, setCubeEnabled] = useLocalStorage(ENVIRONMENT_SETUP_CUBE_STORAGE_KEY, false)
  const canSwitch = isBrowser && isStaff() && isFeatureEnabled(ENVIRONMENT_SETUP_CUBE_FLAG)

  return {
    cubeEnabled: canSwitch && cubeEnabled,
    setCubeEnabled: canSwitch ? setCubeEnabled : undefined,
  }
}
